import { render, staticRenderFns } from "./ManagerAffiliateModal.vue?vue&type=template&id=4a62b924&"
import script from "./ManagerAffiliateModal.vue?vue&type=script&lang=js&"
export * from "./ManagerAffiliateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports